import axios from "axios";

const browserApiUrl = typeof window !== "undefined"
  ? `${window.location.protocol}//${window.location.hostname}:4000/api`
  : "http://localhost:4000/api";
const baseURL = process.env.REACT_APP_API_URL || browserApiUrl;

const api = axios.create({ baseURL });
const apiOrigin = baseURL.replace(/\/api\/?$/, "");

export const mediaUrl = url => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${apiOrigin}${url.startsWith("/") ? url : `/${url}`}`;
};

api.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("business");

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
